import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import React from "react";
import { useEffect, useState, useMemo } from "react";
import styles from "./Maps.module.scss";

type MapProps = {
  center: google.maps.LatLngLiteral;
  containerStyle: React.CSSProperties;
  mapOptions: any;
  poiLocation: any;
  markers: MarkerLocation[];
};

interface MarkerLocation {
  lat: number;
  lng: number;
}

const MemorizedMap: React.FC<MapProps> = React.memo(
  ({ center, containerStyle, mapOptions, poiLocation, markers }) => (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={16}
      options={mapOptions}
      // mapTypeId={"satellite"}
    >
      <Marker position={poiLocation} label="" />
      {markers.map((spot, index) => (
        <Marker
          key={index}
          position={spot}
          label="P"
          icon={{
            path: google.maps.SymbolPath.CIRCLE, // Usa il cerchio come forma del marker
            fillColor: "blue", // Colore di riempimento blu
            fillOpacity: 1, // Opacità del riempimento
            strokeColor: "blue", // Colore del bordo blu
            strokeOpacity: 1, // Opacità del bordo
            scale: 6, // Scala del marker
          }}
        />
      ))}
    </GoogleMap>
  )
);

const Maps = () => {
  // Chiave API di Google Maps
  const apiKey = process.env.REACT_APP_GOOGLE_KEY as string;

  const [parkingSpots, setParkingSpots] = useState<
    { lat: number; lng: number }[]
  >([]);

  // Coordinate del centro della mappa
  const mapCenter = useMemo(
    () => ({ lat: 45.37906761034888, lng: 11.902815047164092 }),
    []
  );

  const containerStyle = useMemo(
    () => ({
      width: "100%",
      height: "100%",
      borderRadius: "10px",
      backgroundColor: "white",
      opacity: 1,
      zIndex: 10,
    }),
    []
  );

  const mapOptions = useMemo(
    () => ({ disableDefaultUI: true, zoomControl: true }),
    []
  );

  const giacomoNani = useMemo(
    () => ({ lat: 45.37997967812532, lng: 11.903031077898373 }),
    []
  );

  const davantiSalone = useMemo(
    () => ({ lat: 45.378954045723205, lng: 11.90280755528079 }),
    []
  );

  const chiesa = useMemo(
    () => ({ lat: 45.379029197528276, lng: 11.90218579772548 }),
    []
  );
  const poiLocation = { lat: 45.37906761034888, lng: 11.902815047164092 };

  // useEffect(() => {
  //   loadGoogleMapsScript();
  // }, []);

  // const loadGoogleMapsScript = async () => {
  //   if (
  //     document.querySelector(
  //       `script[src="https://maps.googleapis.com/maps/api/js?key=${apiKey}"]`
  //     )
  //   ) {
  //     if (window.google && window.google.maps) {
  //       setIsLoaded(true);
  //       return;
  //     }
  //   }

  //   const script = await document.createElement("script");
  //   script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
  //   script.async = true;
  //   script.defer = true;

  //   script.onload = () => {
  //     console.log("Google Maps script caricato con successo!");
  //     setIsLoaded(true);
  //   };
  //   script.onerror = () => {
  //     console.error(
  //       "Errore durante il caricamento dello script di Google Maps."
  //     );
  //     setLoadError("Errore durante il caricamento di Google Maps.");
  //   };
  //   document.head.appendChild(script);
  // };

  // useEffect(() => {
  //   console.log(isLoaded);
  // }, []);

  // if (!isLoaded) {
  //   return <div>Loading map...</div>;
  // }

  useEffect(() => {}, []);

  return (
    <div className="mt-5 d-flex flex-column align-items-center justify-content-center col-12 h-100">
      {/* {isLoaded && ( */}
      <span className="col-12  mb-3 text-tahoma align-items-center justify-content-start d-flex">
        <span
          className={`${styles.parcheggi} d-flex flex-row align-items-center justify-content-center me-3`}
        >
          P
        </span>
        Parcheggi gratuiti raggiungibili facilmente a piedi
      </span>
      <>
        <LoadScript googleMapsApiKey={apiKey}>
          <MemorizedMap
            center={mapCenter}
            containerStyle={containerStyle}
            mapOptions={mapOptions}
            poiLocation={poiLocation}
            markers={[giacomoNani, davantiSalone, chiesa]}
          />
        </LoadScript>
      </>
      {/* )} */}
    </div>
  );
};

export default Maps;
